import { render, staticRenderFns } from "./faqRegistration.vue?vue&type=template&id=fc107554&scoped=true"
import script from "./faqRegistration.vue?vue&type=script&lang=js"
export * from "./faqRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc107554",
  null
  
)

export default component.exports